var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0C164.874 0 91 73.874 91 165C91 245.867 149.218 313.019 226 327.144V376H151V436H226V512H286V436H361V376H286V327.144C362.782 313.019 421 245.867 421 165C421 73.874 347.126 0 256 0ZM256 270C198.109 270 151 222.891 151 165C151 107.109 198.109 60 256 60C313.891 60 361 107.109 361 165C361 222.891 313.891 270 256 270Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/Female.a2d78b5c9f26eb092c2f0f2d4e6dbd1f.svg";
export { ForwardRef as ReactComponent };